import { UnitCategory, UnitDefinition, Units } from './unit-converter.types';

export const unitDefinitions: Record<Units, UnitDefinition> = {
	// Mass
	[Units.kg]: { category: UnitCategory.Mass, factor: 1, base: Units.kg },
	[Units.tonne]: { category: UnitCategory.Mass, factor: 1000, base: Units.kg },
};
